/* eslint-disable no-dupe-keys */
export default {
  settlement_discount: {
    name: '渠道活动',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '活动名',
      calculation_reference: '渠道分成计算参考值',
      discount_type: '折扣类型',
      discount_value: '折扣值',
      service_fee_discount: '服务费优惠',
      per_kwh_discount: '每度电优惠',
      status: '状态',
      begin_time: '活动开始时间',
      end_time: '活动结束时间',
      created_at: '创建时间',
      updated_at: '更新时间',
      effective_time: '活动生效时间',
      charge_station_id: '适用电站',
      charge_channel: '充电渠道',
      effective_date: '生效日期'
    },
    charge_station_prop: {
      name: '电站名',
      address: '地址',
      service_provider_name: '运营商'
    },
    // Enum的属性
    calculation_references: {
      ref_original_amount: '基于原价计算',
      ref_amount_after_sharing: '基于优惠后计算'
    },
    discount_types: {
      per_kwh_discount: '电量优惠',
      service_fee_discount: '服务费优惠'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询活动名',
      input_name: '请输入活动名',
      select_charge_channel: '请选择充电渠道'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标签标题
    // 标题
    titles: {
      base_info: '基本信息',
      charge_station: '适用充电站'
    },
    tips: {
      header: '仅适用于互联互通渠道，记录的是我方平台让利部分',
      confirm_delete_selected: '确认删除当前已选中的渠道活动？'
    },
    btn: {
      delete_selected: '删除已选中活动'
    }
  }
}
